export function validarCpf(valor) {
	const cpf = String(valor || "").replace(/\D/g, "")
	if (!cpf) return ""
	if (!cpfDigitosValidos(cpf)) {
		return "CPF inválido. Confira os números e os dígitos verificadores."
	}
	return ""
}

export function validarChavePix(tipo, valor) {
	const chave = String(valor || "").trim()
	if (!chave) return ""

	const tipoNormalizado = String(tipo || "").toLowerCase()
	if (!tipoNormalizado) return "Selecione o tipo da chave PIX."

	switch (tipoNormalizado) {
		case "cpf":
			if (!cpfDigitosValidos(chave.replace(/\D/g, ""))) {
				return "Chave PIX inválida para o tipo CPF. Confira os números e os dígitos verificadores."
			}
			return ""
		case "cnpj":
			if (!cnpjDigitosValidos(chave)) {
				return "Chave PIX inválida para o tipo CNPJ. Confira o formato e os dígitos verificadores."
			}
			return ""
		case "email": {
			const email = chave.toLowerCase()
			if (email.length > 77 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
				return "Chave PIX inválida para o tipo e-mail."
			}
			return ""
		}
		case "tel":
			if (!telefonePixValido(chave)) {
				return "Chave PIX inválida para o tipo telefone. Informe o DDD e o número com DDI +55."
			}
			return ""
		case "chave":
			if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(chave)) {
				return "Chave PIX inválida. A chave aleatória deve estar no formato XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX."
			}
			return ""
		default:
			return "Tipo de chave PIX não reconhecido."
	}
}

export function inferirTipoPix(valor) {
	const texto = String(valor || "").trim()
	if (!texto) return ""
	if (texto.includes("@")) return "email"
	if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(texto)) return "chave"
	if (texto.startsWith("+") || telefoneComDdi(texto)) return "tel"

	const alfanumerico = texto.replace(/[^A-Za-z0-9]/g, "")
	if (/^\d{11}$/.test(texto.replace(/\D/g, "")) && !/[A-Za-z]/.test(texto)) return "cpf"
	if (/^[A-Z0-9]{14}$/i.test(alfanumerico)) return "cnpj"
	return ""
}

export function valorPixParaCampo(tipo, valor) {
	const texto = String(valor || "").trim()
	if (!texto) return ""

	if (tipo === "cpf") return texto.replace(/\D/g, "")
	if (tipo === "cnpj") return texto.replace(/[^A-Za-z0-9]/g, "").toUpperCase()
	if (tipo === "tel") return telefoneNacional(texto)
	if (tipo === "email") return texto.toLowerCase()
	return texto
}

export function formatarPixLeitura(valor) {
	const tipo = inferirTipoPix(valor)
	const texto = String(valor || "").trim()
	if (!texto) return ""

	if (tipo === "cpf") {
		const digitos = texto.replace(/\D/g, "")
		return digitos.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
	}

	if (tipo === "cnpj") {
		const cnpj = texto.replace(/[^A-Za-z0-9]/g, "").toUpperCase()
		if (cnpj.length !== 14) return texto
		return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8, 12)}-${cnpj.slice(12)}`
	}

	if (tipo === "tel") {
		const digitos = telefoneNacional(texto)
		if (digitos.length === 11) {
			return `+55 (${digitos.slice(0, 2)}) ${digitos.slice(2, 7)}-${digitos.slice(7)}`
		}
		if (digitos.length === 10) {
			return `+55 (${digitos.slice(0, 2)}) ${digitos.slice(2, 6)}-${digitos.slice(6)}`
		}
	}

	return texto
}

export function mascaraPix(tipo) {
	switch (tipo) {
		case "cpf":
			return "999.999.999-99"
		case "cnpj":
			return "**.***.***/****-99"
		case "tel":
			return "+55 99 99999-9999"
		default:
			return ""
	}
}

function cpfDigitosValidos(cpf) {
	if (!/^\d{11}$/.test(cpf)) return false
	if (/^(\d)\1{10}$/.test(cpf)) return false

	for (let tamanho = 9; tamanho < 11; tamanho++) {
		let soma = 0
		for (let i = 0; i < tamanho; i++) {
			soma += Number(cpf[i]) * ((tamanho + 1) - i)
		}
		const digito = ((10 * soma) % 11) % 10
		if (Number(cpf[tamanho]) !== digito) return false
	}

	return true
}

function cnpjDigitosValidos(valor) {
	const cnpj = String(valor || "").toUpperCase().replace(/[^A-Z0-9]/g, "")
	if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(cnpj)) return false
	if (/^(.)\1*$/.test(cnpj)) return false

	const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
	const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
	const base = cnpj.slice(0, 12)
	const d1 = digitoCnpj(base, pesos1)
	const d2 = digitoCnpj(base + d1, pesos2)
	return cnpj.slice(12) === `${d1}${d2}`
}

function digitoCnpj(base, pesos) {
	let soma = 0
	for (let i = 0; i < base.length; i++) {
		soma += (base.charCodeAt(i) - 48) * pesos[i]
	}
	const resto = soma % 11
	return resto < 2 ? 0 : 11 - resto
}

function telefoneNacional(valor) {
	let digitos = String(valor || "").replace(/\D/g, "")
	if (digitos.startsWith("55") && digitos.length > 11) digitos = digitos.slice(2)
	return digitos
}

function telefonePixValido(valor) {
	return /^[1-9]{2}(?:9\d{8}|\d{8})$/.test(telefoneNacional(valor))
}

function telefoneComDdi(valor) {
	const digitos = String(valor || "").replace(/\D/g, "")
	if (!digitos.startsWith("55") || digitos.length < 12) return false
	return telefonePixValido(digitos.slice(2))
}
